import { useState } from 'react';
import { Form, Modal } from 'antd';
import type { AmostraCardData } from './types';

export const useAmostraModal = (
  amostra: AmostraCardData,
  onEdit: (amostra: AmostraCardData) => void,
  onDelete: (identificacao: string) => void
) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const handleEdit = () => {
    form.setFieldsValue(amostra);
    setIsModalOpen(true);
  };

  const handleDelete = () => {
    Modal.confirm({
      title: 'Excluir Amostra',
      content: `Tem certeza que deseja excluir a amostra ${amostra.identificacao}?`,
      okText: 'Sim, excluir',
      cancelText: 'Cancelar',
      okButtonProps: { danger: true },
      onOk: () => onDelete(amostra.identificacao),
    });
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      onEdit({ ...amostra, ...values });
      setIsModalOpen(false);
    } catch (error) {
    }
  };

  return {
    isModalOpen,
    setIsModalOpen,
    form,
    handleEdit,
    handleDelete,
    handleSave,
  };
};
